import { isString } from "lodash"

export const unitFormatter = (unit: string) => {
	if (!isString(unit)) {
		return ""
	}
	return unit
		.replaceAll("^3", "\u00B3")
		.replaceAll("m3", "m\u00B3")
		.replaceAll("^2", "\u00B2")
		.replaceAll("m2", "m\u00B2")
}
